module.exports = __webpack_public_path__ + "04_mole.e69bc0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/04_mole.png
// module id = LK3L
// module chunks = 0